module.exports = __webpack_public_path__ + "static/portfolio-mas-1-e718b7a3194e64dc95f8199b90d4a431.jpg";